import angular from 'angular';
import csmText from '../../text/text';
import csmTools from '../../util/tools/tools';

import { csmValidator } from './csmValidator';
import { csmValidators } from './csmValidators';
import {
  csmValidatorService,
  csmValidatorServiceRun
} from './CSMValidatorService';
import { dateValidator } from './dateValidator';
import { emailValidator } from './emailValidator';
import { numberValidator } from './numberValidator';
import { phoneValidator } from './phoneValidator';
import { taxIdValidator } from './taxIdValidator';
import { textValidator } from './textValidator';
import { urlValidator } from './urlValidator';
import { zipCodeValidator } from './zipCodeValidator';

import './validators.css';

/**
 * @ngdoc    overview
 * @name     csm.ui.validators
 * @description
 * UI input field validators.
 **/
// toastr dependency is the angular UI Toaster library
export default angular
  .module('csm.ui.validators', ['toastr', csmText, csmTools])
  .directive('csmValidator', csmValidator)
  .directive('csmValidators', csmValidators)
  .service('CSMValidatorService', csmValidatorService)
  .run(csmValidatorServiceRun)
  .directive('dateValidator', dateValidator)
  .directive('emailValidator', emailValidator)
  .directive('numberValidator', numberValidator)
  .directive('phoneValidator', phoneValidator)
  .directive('taxIdValidator', taxIdValidator)
  .directive('textValidator', textValidator)
  .directive('urlValidator', urlValidator)
  .directive('zipCodeValidator', zipCodeValidator).name;
